import { render } from "./NotFoundPage.vue?vue&type=template&id=f378f97c&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=f378f97c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f378f97c"],['__file',"src/pages/NotFoundPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f378f97c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f378f97c', __exports__)) {
    api.reload('f378f97c', __exports__)
  }
  
  module.hot.accept("./NotFoundPage.vue?vue&type=template&id=f378f97c&scoped=true", () => {
    api.rerender('f378f97c', render)
  })

}


export default __exports__